import { HealthStatus, PropertyDetails, TagStatus, UpdatePropertyTag } from '@admin/core/models';
import { HealthValues, TagStatusValues } from '@admin/shared/data';
import { formControl } from '@al00x/forms';
import { Component, inject } from '@angular/core';
import {
  ButtonClickEvent,
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  CacFormBuilderComponent,
  formBuilder,
} from '@controladad/ng-base';
import { ImageViewerComponent } from "@admin/shared";
import { PropertyApiService } from '@admin/core';
import { isChangingTagStatusValid, personnelToString } from '@admin/shared/helpers/utility.helper';

export type PropertyPageMode = 'property' | 'property-tag';


export interface PropertyDialogData {
  mode: PropertyPageMode;
  property: PropertyDetails;
};

export type PropertyDialogResult = boolean;

@Component({
  selector: 'app-property-dialog',
  imports: [CacDialogLayoutComponent, CacFormBuilderComponent, ImageViewerComponent],
  templateUrl: './property-dialog.component.html',
})
export class PropertyDialogComponent extends CacBaseDialogComponent<PropertyDialogData, PropertyDialogResult> {
  private readonly propertyApi = inject(PropertyApiService);

  formBuilder = formBuilder({
    cols: 6,
    defaults: {
      colspan: 2,
    },
    inputs: {
      name: {
        control: formControl<string>(undefined),
        label: 'نام',
      },
      code: {
        control: formControl<string>(undefined),
        label: 'کد',
      },
      tagSerial: {
        control: formControl<string>(undefined),
        label: 'سریال تگ',
      },
      locationName: {
        control: formControl<string>(undefined),
        label: 'مکان',
      },
      healthStatus: {
        control: formControl<HealthStatus>(undefined),
        label: 'وضعیت سلامت',
        type: 'select',
        searchable: false,
        clearable: false,
        items: HealthValues,
      },
      tagStatus: {
        control: formControl<TagStatus>(undefined),
        label: 'وضعیت تگ',
        type: 'select',
        searchable: false,
        clearable: false,
        items: TagStatusValues,
        hidden: this.data.mode === 'property',
      },
      mainPersonnel: {
        control: formControl<string | undefined>(undefined),
        label: 'تحویل گیرنده اصلی',
        colspan: 3,
      },
      secondPersonnel: {
        control: formControl<string | undefined>(undefined),
        label: 'تحویل گیرنده دوم',
        colspan: 3,
      },
      description: {
        control: formControl<string>(undefined),
        label: 'توضیحات',
        type: 'textarea',
        colspan: 6,
      },
    },
    onInit: () => {
      const property = this.data.property;
      this.formBuilder.setValue({
        ...property,
        mainPersonnel: personnelToString(property.personnel.at(0)),
        secondPersonnel: personnelToString(property.personnel.at(1)),
      });
      this.formBuilder.setReadonly(true);
      if (this.data.mode === 'property-tag') {
        this.formBuilder.setReadonly(false, 'tagStatus', 'tagSerial');
      }
    },
  });

  onSubmit(e: ButtonClickEvent) {
    const values = this.formBuilder.getValue();
    if (!values) return;
    const tagStatus = values.tagStatus;

    if (!isChangingTagStatusValid(this.data.property.tagStatus, tagStatus, true)) return;

    const model: UpdatePropertyTag = {
      id: this.data.property.id,
      tagStatus: { value: tagStatus },
      tagSerial: { value: values.tagSerial },
    };
    this.propertyApi.bulkUpdatePropertyTags([model]).pipe(e.pipe()).subscribe(() => {
      this.submit(true);
    });
  }
}
